import type { FormInputType } from '@/components/UI/Form/types'

export default function getAdminSessionPartnerJoinLinkFormInputs(): FormInputType[] {
  return [
    {
      type: 'text',
      label: 'First Name',
      name: 'firstName',
      size: 3,
      required: true,
    },
    {
      type: 'text',
      label: 'Last Name',
      name: 'lastName',
      size: 3,
      required: true,
    },
  ]
}
